module.exports = __webpack_public_path__ + "img/IMG_1454_L.28aed5ca.webp";